import type { Locale } from "./i18n";

const releaseBase = "https://github.com/silosaveapp/silosave-desktop-downloads/releases/download";
export const desktopDownloads = {
  windows: `${releaseBase}/v0.1.7/SiloSave-Desktop-Setup-0.1.7.exe`,
  macArm64: `${releaseBase}/v0.1.7/SiloSave-Desktop-0.1.7-mac-arm64-preview.dmg`,
  macX64: `${releaseBase}/v0.1.7/SiloSave-Desktop-0.1.7-mac-x64-preview.dmg`,
};

const labels: Record<Locale, { windows: string; preview: string }> = {
  en: { windows: "Download for Windows", preview: "Preview" },
  "zh-tw": { windows: "下載 Windows 版", preview: "預覽版" },
  "zh-cn": { windows: "下载 Windows 版", preview: "预览版" },
  ja: { windows: "Windows 版をダウンロード", preview: "プレビュー版" },
  ko: { windows: "Windows 버전 다운로드", preview: "미리 보기" },
  es: { windows: "Descargar para Windows", preview: "Versión preliminar" },
  "pt-br": { windows: "Baixar para Windows", preview: "Prévia" },
  fr: { windows: "Télécharger pour Windows", preview: "Préversion" },
  de: { windows: "Für Windows herunterladen", preview: "Vorschau" },
  id: { windows: "Unduh untuk Windows", preview: "Pratinjau" },
  vi: { windows: "Tải bản Windows", preview: "Bản xem trước" },
  th: { windows: "ดาวน์โหลดสำหรับ Windows", preview: "รุ่นทดลอง" },
};

export function getDesktopDownloadCopy(locale: Locale) { return labels[locale]; }
